import { useState, useEffect } from 'react';

// This hook accepts a scroll threshold parameter
const useScrollBeyondThreshold = (threshold: number): boolean => {
    // State to keep track of whether the scroll has passed the threshold
    const [hasScrolledBeyond, setHasScrolledBeyond] = useState<boolean>(false);

    // Effect to add event listener to window scroll
    useEffect(() => {
        const handleScroll = () => {
            // Update state based on scroll position
            setHasScrolledBeyond(window.scrollY > threshold);
        };

        // Add event listener
        window.addEventListener('scroll', handleScroll);

        // Clean up event listener on component unmount
        return () => window.removeEventListener('scroll', handleScroll);
    }, [threshold]);

    return hasScrolledBeyond;
};

export default useScrollBeyondThreshold;
